import { render, staticRenderFns } from "./TableBulkActionsPopover.vue?vue&type=template&id=00ade160&scoped=true"
import script from "./TableBulkActionsPopover.vue?vue&type=script&lang=ts"
export * from "./TableBulkActionsPopover.vue?vue&type=script&lang=ts"
import style0 from "./TableBulkActionsPopover.vue?vue&type=style&index=0&id=00ade160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ade160",
  null
  
)

export default component.exports